import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, sgd, formatSG } from "@/lib/api";
import { Loader2, Check } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [polls, setPolls] = useState(0);
  const { clear } = useCart();

  useEffect(() => {
    if (!sid) return;
    let mounted = true;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (!mounted) return;
        setStatus(data);
        if (data.payment_status === "paid") { clear(); return; }
      } catch {}
      if (mounted && polls < 15) setTimeout(() => setPolls(p => p + 1), 2000);
    };
    tick();
    // eslint-disable-next-line
  }, [sid, polls]);

  const closeFmt = formatSG(status.preorder_close_date);
  const shipFmt = status.preorder_close_date ? formatSG((() => {
    const [y, m, d] = status.preorder_close_date.split("-").map(n => parseInt(n, 10));
    const dt = new Date(Date.UTC(y, m - 1, d));
    dt.setUTCDate(dt.getUTCDate() + 14);
    return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}`;
  })()) : "";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-success">
        {status.payment_status === "paid" ? (
          <>
            <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center" style={{ background: "#EBE5ED" }}>
              <Check size={22} strokeWidth={1.5} style={{ color: "#4A464A" }} />
            </div>
            <div className="text-[11px] uppercase tracking-editorial text-[#C3B1C5] mt-6">
              {status.was_preorder ? "◈ Pre-order Confirmed" : "◈ Order Confirmed"}
            </div>
            <h1 className="font-serif-display text-[36px] mt-2 tracking-tight">
              {status.was_preorder ? "Your pre-order is confirmed ♡" : "Thank you, love ♡"}
            </h1>
            {status.was_preorder ? (
              <p className="mt-4 text-[14px] text-[#4A464A]/80 leading-relaxed" data-testid="success-preorder-note">
                Soft launch orders close on <strong>{closeFmt}</strong>, and all orders ship from <strong>{shipFmt}</strong>. We'll let you know when yours is on the way.
              </p>
            ) : (
              <p className="mt-4 text-[14px] text-[#4A464A]/75">Your ONE LOOK is on its way. A confirmation email is coming your way.</p>
            )}
            {status.amount && <p className="mt-4 text-[13px] tracking-editorial">Total · {sgd(status.amount)}</p>}
          </>
        ) : (
          <>
            <Loader2 className="animate-spin mx-auto" size={22} />
            <div className="mt-6 font-serif-display text-[24px]">Confirming your order…</div>
            <p className="mt-3 text-[13px] text-[#4A464A]/70">This should only take a moment.</p>
          </>
        )}
        <Link to="/looks" className="inline-block mt-10 px-6 py-3 text-[11px] uppercase tracking-editorial border" style={{ borderColor: "#4A464A" }}>Continue Shopping</Link>
      </div>
    </div>
  );
}
